/**
 * Budgets selectors (PX-W6.4). Straight projections of the slice — the
 * totals render verbatim from the view, so there is nothing to derive.
 */

import type { BudgetVsActualView, ProjectBudget } from './types'
import type { BudgetsState } from './slices/budgetsSlice'

interface WithBudgets {
  budgets: BudgetsState
}

export const selectActiveBudget = (s: WithBudgets): ProjectBudget | null => s.budgets.active
export const selectActiveBudgetMissing = (s: WithBudgets): boolean => s.budgets.activeMissing
export const selectBudgetHistory = (s: WithBudgets): ProjectBudget[] => s.budgets.history
export const selectBudgetVsActual = (s: WithBudgets): BudgetVsActualView | null => s.budgets.view
export const selectBudgetsLoading = (s: WithBudgets): boolean =>
  s.budgets.caches.active.loading ||
  s.budgets.caches.history.loading ||
  s.budgets.caches.view.loading
export const selectBudgetsError = (s: WithBudgets) => s.budgets.error
export const selectBudgetsMutating = (s: WithBudgets): boolean => s.budgets.mutating
